// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c5eaf93b","876":"23ade2d0"}[chunkId] + ".chunk.js";
};